import { useEffect } from 'react'
import { useLogin } from '../hooks/useLogin'
import { useLogout } from '../hooks/useLogout'
import { getCurrentUser } from '../functions/api'

const WindowEvents = () => {
  const { login } = useLogin()
  const { logout } = useLogout()

  useEffect(() => {
    const checkSession = async () => {
      const user = await getCurrentUser()
      if (user) login(user)
      else logout()
    }

    checkSession()
  }, [login, logout])

  return <></>
}

export default WindowEvents